<template lang="pug">
.list-responsavel
  div(v-for="assinador in assinadores")
    span {{assinador.responsavel.usuario.pessoa.pessoaFisica.nome}}
    el-tooltip(v-if="showIcon" :content="assinador.assinado ? 'Assinado' : 'Aguardando assinatura' " placement="top")
      i(:class="assinador.assinado ? 'far fa-check-circle success' : 'far fa-clock' ")

</template>

<script>
export default {
  props: {
    assinadores: {
      required: true,
      default: () => []
    },
    showIcon: {
      default: true
    }
  }
}

</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.list-responsavel {
  display: flex;
  flex-direction: column;
  div {
    padding: 5px;
    display: flex;
    align-items: center;
    span {
      margin-right: 10px;
    }
  }
}
.success {
  color: $color-primary;
}
</style>



// WEBPACK FOOTER //
// src/screens/assinatura/components/ListResponsavelAssinatura.vue